import { Box, Stack, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router";

function BusinessLocationsWithChargingTable(props: any) {
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      sortable: false,
      width: 150,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "addressLine",
      headerName: "Address",
      sortable: false,
      width: 240,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "countFastChargers",
      headerName: "Fast Charging Units",
      sortable: false,
      width: 180,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "countRapidChargers",
      headerName: "Rapid Charging Units",
      sortable: false,
      width: 180,
      align: "right",
      headerAlign: "right",
    },
    // {
    //   field: "priceRapidCharger",
    //   headerName: "Rapid Charging Cost",
    //   sortable: false,
    //   width: 150,
    //   align: "right",
    //   headerAlign: "right",
    //   valueFormatter: (params) => {
    //     // Assuming the price is in a format that can be converted to a number
    //     const price = params;
    //     // Format the price as currency, e.g., '$123.45'
    //     // Adjust 'en-US' and 'USD' to fit the locale and currency you need
    //     return new Intl.NumberFormat('en-UK', {
    //       style: 'currency',
    //       currency: 'GBP',
    //     }).format(price);
    // }
    // },
  ];

  const CustomNoRowsOverlay = () => (
    <Stack height="100%" alignItems="center" justifyContent="center" p={2}>
      <Typography color="text.secondary">
        No Infrastructure Locations exist.
      </Typography>
    </Stack>
  );

  const CustomNoResultsOverlay = () => (
    <Stack height="100%" alignItems="center" justifyContent="center" p={2}>
      <Typography color="text.secondary">
        Selected filter returns no result
      </Typography>
    </Stack>
  );

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <DataGrid
        rows={props.data}
        columns={columns}
        autoHeight
        disableColumnMenu
        initialState={{
          pagination: {
            paginationModel: { pageSize: 15, page: 0 },
          },
        }}
        pageSizeOptions={[15]}
        disableRowSelectionOnClick
        slots={{
          noRowsOverlay: CustomNoRowsOverlay,
          noResultsOverlay: CustomNoResultsOverlay,
        }}
        sx={{
          '& .MuiDataGrid-cell': {
            fontFamily: 'inherit'
          },
          '& .MuiDataGrid-columnHeaders': {
            fontFamily: 'inherit'
          }
        }}
      />
    </Box>
  );
}

export default BusinessLocationsWithChargingTable;
